import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection, LeadingTitle } from '@components'
import './CreditCardDetail.scss'
import { CreditCardAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import CardHover from '../../../common/components/Cards/CardHover'
import CardSection from '../../../common/components/Cards/CardSection'
import BenefitCard from '../../../common/components/BenefitCard'
import CardFeature from '../../../common/components/Cards/CardFeature'
import CardDownload from '../../../common/components/Cards/CardDownload'

const CreditCardDetailContainer = styled.div`
  padding-top: 70px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const Span = styled.span`
  font-size: 14px;
  line-height: 150%;
  color: rgb(242, 169, 0);
`

const H1 = styled.h1`
  font-family: KBFGDisplay;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 48px;
  color: rgb(94, 81, 77);
`

const H2 = styled.h2`
  font-family: KBFGDisplay;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
  color: black;
`

const Img = styled.img`
  width: 100%;
  height: 240px;
  border-radius: 12px 0px 12px 12px;
  object-fit: cover;
  @media (min-width: 992px) {
    height: 343px;
  }
`

const CreditCardDetail = function () {
  const { t } = useTranslation()

  const { id } = useParams()
  const [data, setdata] = useState({})
  const [dataCredit, setDataCredit] = useState({})
  const [isLoading, setisLoading] = useState(true)

  useEffect(() => {
    setisLoading(true)
    const loadData = async function () {
      const reportData = await CreditCardAPI(`/${id}`)
      let { data } = reportData.data

      data['blockDataBenefit'] = data.blockDataBenefit.map((x) => {
        return {
          title: x.titleBenefit,
          icon: x.iconBenefit,
          description: x.descriptionBenefit,
        }
      })

      data['blockDataFeature'] = data.blockDataFeature.map((x) => {
        return {
          title: x.titleFeature,
          description: x.descriptionFeature,
        }
      })
      setdata(data)
      loadDataCredit()
    }

    const loadDataCredit = async function () {
      const reportData = await CreditCardAPI('')
      setDataCredit(reportData.data.data)
      setisLoading(false)
    }

    loadData()
  }, [])

  return (
    <CreditCardDetailContainer>
      <div className="p-0 m-0 container-fluid">
        <div className="pt-4 px-3 pb-0">
          <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex position-relative row">
            <div className="position-relative p-0 order-lg-2 mb-lg-5 col-lg-9 col-12">
              <Desktop>
                <Img src={data.imageBannerDesktop} />
              </Desktop>
              <Mobile>
                <Img src={data.imageBannerMobile} />
              </Mobile>
              <div className="position-relative">
                <div className="py-4 px-3 px-lg-6 myContainer">
                  <Desktop>
                    <CardSection
                      title={data.title}
                      description={data.description}
                      textButton={t('dapatkan_sekarang')}
                      // linkButton={"/"}
                      url={data.imageCardDesktop}
                      // showButton={true}
                      showCardImage={data.imageCardDesktop==null ? false : true}
                    />
                  </Desktop>

                  <Mobile>
                    <CardSection
                      title={data.title}
                      description={data.description}
                      textButton={t('dapatkan_sekarang')}
                      // linkButton={"/"}
                      url={data.imageCardMobile}
                      // showButton={true}
                    />
                  </Mobile>

                  <div className="container-fluid">
                    <div className="mb-4 mt-4 flex align-items-center position-relative row">
                      {/* <p>{data.imageCardDesktop}</p> */}
                      <CardFeature
                        items={isLoading ? [] : data.blockDataFeature}
                        title={t('fitur_yang_di_dapat')}
                      />
                    </div>
                  </div>

                  {typeof data.blockDataBenefit != 'undefined' &&
                    data.blockDataBenefit.length > 0 && (
                      <div className="container-fluid">
                        <div className="mb-4 mt-4 flex align-items-center position-relative row">
                          {/* <p>{data.imageCardDesktop}</p> */}
                          <BenefitCard
                            title={t('benefit_yang_di_dapat')}
                            items={isLoading ? [] : data.blockDataBenefit}
                          />
                        </div>
                      </div>
                    )}

                  {typeof data.blockDataLainya != 'undefined' &&
                    data.blockDataLainya.length > 0 && (
                      <div className="container-fluid">
                        <div className="mb-4 mt-4 flex align-items-center position-relative row">
                          <H2>{t('detail_terkait_lainnya')}</H2>
                        </div>
                        <div className="row">
                          {isLoading
                            ? []
                            : data.blockDataLainya.map((item) => {
                                return (
                                  <div className="col-lg-6 col-12">
                                    <CardDownload
                                      text={item.titleLainya}
                                      link={item.linkLainya}
                                    />
                                  </div>
                                )
                              })}
                        </div>
                      </div>
                    )}

                  <div className="container-fluid">
                    <div className="mb-4 mt-4 flex align-items-center position-relative row">
                      <H2>{t('bandingkan_dengan')}</H2>
                    </div>
                    <div className="row">
                      {isLoading
                        ? []
                        : dataCredit.map((item) => {
                            return (
                              <div className="col-lg-4">
                                <CardHover
                                  title={item.title}
                                  url={item.imageCardDesktop}
                                  link={'/credit-card/' + item.id}
                                />
                              </div>
                            )
                          })}
                    </div>
                    {/* <div className="row mt-2">
                      <div className="col-lg-12">
                        <a
                          href="#"
                          type="button"
                          className="btn btn-primary btn-lg text-center d-block"
                        >
                          {t("dapatkan_kartu", {
                            kartu: isLoading ? "" : data.title,
                          })}
                        </a>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="order-lg-1 px-3 pe-lg-4 col-lg-3 col-12">
              <Span>{t('your_daily_solution')}</Span>
              <H1>{data.title}</H1>
              <p
                className="mb-3"
                style={{
                  color: 'rgb(138, 141, 143)',
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  fontSize: '14px',
                  lineHeight: '150%',
                }}
              >
                {t('kartu_kredit_lainnya')}
              </p>
              {isLoading
                ? []
                : dataCredit.map((item) => {
                    return (
                      <CardHover
                        title={item.title}
                        url={item.imageCardDesktop}
                        link={'/credit-card/' + item.id}
                      />
                    )
                  })}
            </div>
          </div>
        </div>
      </div>

      <FooterSection currentPage={t('kartu_kredit')} />
    </CreditCardDetailContainer>
  )
}

export default CreditCardDetail
